/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Попап с информацией о недоступности быстрой доставки
   */
  app.FastDeliveryPopup = app.ItemsPopupView.extend({
    el: '.js-fast-delivery-popup',
    /**
     * @inheritDoc
     */
    run: function () {
      this.initPopup();
      this.listenTo(Backbone, 'show-fast-delivery-popup', this.render);
    },

    /**
     * Показать попап
     * @param {app.Item} model Модель товара
     * @param {jQuery} $qty Элемент qty-view, с которого был добавлен товар
     */
    render: function (model, $qty) {
      this.$('.js-fast-delivery-balance').html(model.get('fast_delivery_balance'));

      var qtyPosition = $qty.offset();
      this.$el.css({
        left: qtyPosition.left - 2,
        top: qtyPosition.top - this.$el.height() - 40,
      });
      this.open();
    },

    /**
     * Открываем попап
     */
    open: function () {
      // костыль для лебедевского попапа
      setTimeout(this.popup.open.bind(this.popup), 1);
    },

    /**
     * Инициализация попапа
     */
    initPopup: function () {
      this.popup = new als.Popup(this.$el);
    },
  });
})();

}.call(window));